// contains shared functionality between product-main and product-secondary
import { removeFalsy } from '../helpers/utils';
import { FIT_FINDER_TO_FIT, FIT_FINDER_TO_SIZE } from '../constants/fits.constants';
export const NO_SELECTED_VARIANT = undefined;
export const UNAVAILABLE_VARIANT = null;
const PROP_TO_DISPLAY_MAP = {
    fit: FIT_FINDER_TO_FIT,
    size: FIT_FINDER_TO_SIZE
};
export function getRecommendationParameters(options) {
    return Object.entries(options).map((entry) => {
        const [key, val] = entry;
        const mapper = PROP_TO_DISPLAY_MAP[key];
        if (!val)
            return;
        if (mapper) {
            const displayValue = mapper.get(val) || val.charAt(0).toUpperCase() + val.replace(/-/g, " ").slice(1); // we need a fallback for something like "size-2", which doesn't exist in the map
            if (displayValue) {
                return { [key]: displayValue };
            }
        }
        else {
            return { [key]: val };
        }
    }).reduce((acc, curr) => {
        return { ...acc, ...curr };
    }, {});
}
export function allOptionsSelected(selectedOptions) {
    return Object.values(selectedOptions).reduce((acc, curr) => {
        return acc && !!curr;
    }, true);
}
export function shownVariant(v) {
    return v.hideVariant !== "true";
}
/**
 *
 * determines whether a variant matches both the passed in option as well as other already-selected options
 * for example, if we want to determine the state of the regular fit option (in stock, out of stock, low stock),
 * we need to see if there are any variants that match fit = regular, as well as any other options the user selected (like, size = small, for example)
 *
 */
export function matchesCurrentAndSelectedOptions(variant, currentOptionName, currentOptionValue, selectedOptions) {
    const optionsToMatch = removeFalsy({ ...selectedOptions, ...{ [currentOptionName]: currentOptionValue } });
    return Object.entries(optionsToMatch).reduce((acc, curr) => {
        const [key, val] = curr;
        return acc && variant.optionsMap[key] === val;
    }, true);
}
